@use './variables' as *;
@use '../../styles/abstracts/break-points' as *;

:host {
  display: $question-host-display;
}

@mixin reset() {
  margin: 0;
  padding: 0;
}

.question {
  display: $question-display;
  margin-bottom: $question-margin-bottom;

  h2 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    color: $question-header-color;
    font-family: $question-header-font-family;
    font-size: $question-header-font-size;
    font-weight: $question-header-font-weight;
    line-height: $question-header-line-height;
    text-decoration: $question-header-text-decoration;
    text-transform: $question-header-text-transform;
    margin-top: $question-header-margin-top;
    margin-bottom: $question-header-margin-bottom;

    p {
      @include reset();
    }
  }

  .info {
    cursor: pointer;
    float: right;
  }

  .group-title {
    color: $question-group-title-color;
    font-family: $question-group-title-font-family;
    font-size: $question-group-title-font-size;
    font-weight: $question-group-title-font-weight;
    line-height: $question-group-title-line-height;
    margin-top: $question-group-title-margin-top;
    margin-bottom: $question-group-title-margin-bottom;
  }

  .description {
    color: $question-description-color;
    font-family: $question-description-font-family;
    font-size: $question-description-font-size;
    font-weight: $question-description-font-weight;
    line-height: $question-description-line-height;
    margin-top: $question-description-margin-top;
    margin-bottom: $question-description-margin-bottom;
  }

  .form-element-wrapper {
    display: flex;
    flex-direction: column;
  }
}

@media (max-width: $breakpoint-mobile) {
  .form-element {
    width: $mobile-question-form-element-width;
  }
}
